/* ActiveDockletsComponent.js */

"use strict";
const EventEmitter = require("events");
const Renderer = require("./ActiveDockletsRenderer");

class ActiveDockletsComponent extends EventEmitter {
    constructor(config) {
        super();
        this._state = config.state;
        this._renderer = new Renderer(this);
        this.toggleOnIconClick = false;
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _registerListeners() {
        this._state.on("stateChanged", (this._onStateChanged = this._onStateChanged.bind(this)));
    }

    _unregisterListeners() {
        this._state.removeListener("stateChanged", this._onStateChanged);
        this.removeAllListeners();
    }

    _onStateChanged() {
        if (!this._state.disabled) {
            this.renderer.render();
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */

    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    gearIconClicked() {
        this._state.toggleOptionsOpened();
    }

    dockletClicked(id) {
        this._state.dockletClicked = true;
        // this.emit('openDockletRequest', id);
        if (!this._state.optionsOpened) {
            if (
                this.toggleOnIconClick &&
                this._state.openedPartId !== null &&
                this._state.openedPartId === id
            ) {
                this._state.openedPartId = null;
            } else {
                this._state.openedPartId = id;
            }
        } else {
            this._state.removePart(id);
        }
    }

    getPartIds() {
        return this._state.activePartIds;
    }

    /**
     * return a single part instance
     * @param {String} id
     */
    getPart(id) {
        return this._state.getActivePart(id);
    }

    shutdown() {
        this._unregisterListeners();
        this._state = null;
        this._renderer = null;
        this.emit("Shutdown");
        return Promise.resolve();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = ActiveDockletsComponent;
